export default __webpack_public_path__ + "static/media/home-photography-bg-img-06.1fd9c4c5.jpg";